import {atom} from 'recoil';

export const overlayProppress = atom({
    key: 'overlayProppress',
    default: false,
});